import React, { useState, useEffect, useCallback } from "react";
import { Sun, Moon } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Manifesto } from "../components/Manifesto";
import { Fleet } from "../components/Fleet";
import { Services } from "../components/Services";
import { Reviews } from "../components/Reviews";
import { BookingForm } from "../components/BookingForm";
import { Footer } from "../components/Footer";
import { InstallPrompt } from "../components/InstallPrompt";
import { InstallBanner } from "../components/InstallBanner";
import { TripProvider } from "../context/TripContext";

const PREF_KEY = "nl_theme_pref";
// AM (before noon) => light "day" theme, PM => dark "night" theme, based on visitor's local time.
const autoTheme = () => (new Date().getHours() < 12 ? "day" : "night");
const initialTheme = () => localStorage.getItem(PREF_KEY) || autoTheme();

export default function Home() {
  const [theme, setTheme] = useState(initialTheme);

  // Auto-follow the clock only while the visitor hasn't set a manual preference.
  useEffect(() => {
    const n = Number(localStorage.getItem("nl_visits") || "0") + 1;
    localStorage.setItem("nl_visits", String(n));
    const id = setInterval(() => {
      if (!localStorage.getItem(PREF_KEY)) setTheme(autoTheme());
    }, 60000);
    return () => clearInterval(id);
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme((t) => {
      const next = t === "day" ? "night" : "day";
      localStorage.setItem(PREF_KEY, next);
      return next;
    });
  }, []);

  return (
    <div className="grain relative bg-[var(--nl-bg)]" data-theme={theme} data-testid="home-page">
      <TripProvider>
        <Navbar />
        <Hero />
        <Marquee />
        <Manifesto />
        <Fleet />
        <Services />
        <Reviews />
        <BookingForm />
        <Footer />
        <InstallPrompt />
        <InstallBanner />
      </TripProvider>

      <button
        onClick={toggleTheme}
        aria-label="Toggle light or dark theme"
        title={theme === "day" ? "Switch to dark" : "Switch to light"}
        className="fixed bottom-6 left-6 z-[60] w-12 h-12 rounded-full flex items-center justify-center border border-[var(--nl-border-gold)] text-[var(--nl-gold)] bg-[var(--nl-bg-2)]/80 backdrop-blur-md hover:border-[var(--nl-gold)] hover:scale-105 transition-all duration-300 shadow-lg"
        data-testid="theme-toggle"
      >
        {theme === "day" ? <Moon size={18} /> : <Sun size={18} />}
      </button>
    </div>
  );
}
